import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPuntoPosteManagementState } from './punto-poste-management';

const puntoPosteManagementSelector = createFeatureSelector<IPuntoPosteManagementState>('puntoPosteManagement');

export const selectResponseAnagrafica = createSelector(
  puntoPosteManagementSelector,
  (state: IPuntoPosteManagementState) => state.responseAnagrafica
);

export const selectResponseCambioPassword = createSelector(
  puntoPosteManagementSelector,
  (state: IPuntoPosteManagementState) => state.responseCambioPassword
);

export const selectResponseOrariChiusure = createSelector(
  puntoPosteManagementSelector,
  (state: IPuntoPosteManagementState) => state.responseOrariChiusure
);

export const selectResponsePutOrariChiusure = createSelector(
  puntoPosteManagementSelector,
  (state: IPuntoPosteManagementState) => state.responseOrariChiusurePut
);

export const selectBoardList = createSelector(
  puntoPosteManagementSelector,
  (state: IPuntoPosteManagementState) => state.responseBacheca
);





